import React from "react";
import { styled } from "@mui/system";
import {
  DISPLAY_FLEX,
  FLEX_DIRECTION_COLUMN,
  FLEX_DIRECTION_ROW,
  FLEX_ALIGN_CENTER,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  FONT_WEIGHT_BOLD,
  FLEX_ALIGN_START,
  BORDER_PRIMARY,
} from "../../config/styles";
import { colors } from "../../config/colors";

export const GlobalSearchStyled = styled("div")(({ theme }) => ({
  display: DISPLAY_FLEX,
  flexDirection: FLEX_DIRECTION_COLUMN,
  backgroundColor: theme.palette.secondary.contrastText,
  height: "100vh",
  width: "100vw",
  "& .welcome-page-container": {
    marginLeft: "220px",
    backgroundColor: theme.palette.secondary.contrastText,
    borderRadius: "12px 0px",
  },
  "& .welcome-page-header": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    padding: "36px 40px",
  },
  "& .search-icon-text": {
    ...theme.typography.h4,
    fontWeight: FONT_WEIGHT_BOLD,
    color: colors.grayLight,
  },
  "& .search-page-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    alignItems: FLEX_ALIGN_CENTER,
    width: "400px",
    padding: "24px",
    gap: "8px",
    borderRadius: "8px",
    border: BORDER_PRIMARY,
    backgroundColor: theme.palette.secondary.contrastText,
  },
  "& .search-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    alignItems: FLEX_ALIGN_START,
    padding: "8px 40px",
  },
  "& .search-bar-item": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    padding: "8px 0",
    gap: "8px",
    width: " calc(100vw - 280px)",
  },
  "& .search-bar-logo-item": {
    display: DISPLAY_FLEX,
    width: "48px",
    height: "48px",
    padding: "8px",
    gap: "8px",
    alignItems: FLEX_ALIGN_CENTER,
    justifyContent: FLEX_ALIGN_CENTER,
    borderRadius: "8px",
    border: BORDER_PRIMARY,
    backgroundColor: theme.palette.secondary.contrastText,
  },
  "& .search-bar-input": {
    ...theme.typography.body1,
    overflow: "hidden",
    color: colors.grayLight,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textDecoration: "none",
  },
  "& .search-page-empty-text": {
    ...theme.typography.subtitle2,
    color: colors.grayLight,
    textAlign: "center",
  },
}));
